<template>

    <div class="pclogin">
        <el-dialog :close-on-click-modal='false' custom-class='loginclass' title="登录" @close="dialogClose"
            :modal-append-to-body='false' :visible.sync="islogin">

            <el-form v-if="isphone" ref="loginForm" :model="form" :rules="rules" class="login-box">
                <el-form-item label="" prop="phone">
                    <el-input type="text" maxlength="11" suffix-icon="el-icon-mobile-phone" placeholder="请输入手机号"
                        v-model="form.phone" />
                </el-form-item>
                <el-form-item label="" prop="code">
                    <div class="verify-wrapper">
                        <el-input type="text" maxlength="6" suffix-icon="el-icon-lock" placeholder="请输入验证码"
                            v-model="form.code" />
                        <el-button class="btn-orange" :disabled="disabled" @click="getCode">{{ valiBtn }}</el-button>
                    </div>
                </el-form-item>
                <el-form-item>

                    <button class="d-btn-orange" @click.prevent="onSubmit('loginForm')">确定</button>
                    <p @click="changedl(1)" class="dlfs">账号密码登录</p>
                </el-form-item>

                <p class="txttt">登录即代表你同意 <span><a target="_blank"
                            href="https://web.imbeiyu.com/mobile/helper/protocolNnxqIOS.html">《用户服务协议》</a>
                    </span>和<span><a target="_blank"
                            href="https://web.imbeiyu.com/mobile/helper/privacyNnxqIOS.html">《用户隐私声明》</a> </span> </p>
            </el-form>
            <el-form v-if="!isphone" ref="loginForm" :model="form2" :rules="rules" class="login-box">
                <el-form-item label="" prop="nnid">
                    <el-input type="text" maxlength="11" placeholder="请输入暖暖星球ID/手机号" v-model="form2.nnid" />
                </el-form-item>
                <el-form-item label="" prop="psd">
                    <div class="verify-wrapper">
                        <el-input placeholder="请输入密码" v-model="form2.psd" show-password></el-input>

                    </div>
                </el-form-item>



                <el-form-item>

                    <button class="d-btn-orange" @click.prevent="login('loginForm')">确定</button>
                    <!-- <p @click="changedl(2)" class="dlfs">手机验证码登录</p> -->
                </el-form-item>

                <!-- <el-form-item style="width: 100%;">
                                  <p class="qtdltxt">其他登录方式</p>
                                  <div class="qtbuns">
                                    <button @click.prevent=" loginqt('qq')" class="d-btn-qq"></button>
                                       <button @click.prevent=" loginqt('wx')" class="d-btn-wx"></button>
                                   </div>     
                         
                                </el-form-item>  -->
                <p class="txttt">登录即代表你同意 <span> <a target="_blank"
                            href="https://web.imbeiyu.com/mobile/helper/protocolNnxqIOS.html">《用户服务协议》</a>
                    </span>和<span><a target="_blank"
                            href="https://web.imbeiyu.com/mobile/helper/privacyNnxqIOS.html">《用户隐私声明》</a> </span> </p>
            </el-form>


        </el-dialog>



    </div>

</template>
<script>
export default {
    name: 'pclogin',
    props: {
        dialogFlag: {
            type: Boolean,
            default: false
        },
    },
    data() {
        var checkPhone = (rule, value, callback) => {
            const reg = /^0?(13[0-9]|15[012356789]|18[0-9]|14[578]|16[6]|17[035768]|19[19])[0-9]{8}$/
            if (reg.test(value)) {
                return callback();
            }
            callback('请输入合法的手机号');
        };
        return {

            isphone: false,
            islogin: false,
            form: {
                phone: '',
                code: ''
            },
            form2: {
                nnid: '',
                psd: ''
            },
            autoLogin: false,
            rules: {
                phone: [{ validator: checkPhone, required: true, trigger: 'blur' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                nnid: [{ required: true, message: '请输入暖暖星球ID/手机号', trigger: 'blur' }],
                psd: [{ required: true, message: '请输入登录密码', trigger: 'blur' }]
            },
            dialogVisible: false,     // 对话框显示和隐藏
            valiBtn: '获取验证码',
            disabled: false,
        }
    },
    created() {
        // this.play();
        setTimeout(() => {
            this.num = sessionStorage.getItem("toptab")
            console.log(999)
            console.log(sessionStorage.getItem("toptab"))
        }, 200)




    },
    watch: {
        dialogFlag() {
            this.islogin = this.dialogFlag;
        },
    },
    methods: {
        dialogClose() {
            this.$emit("update:dialogFlag", false);
        },
        loginqt(e) {
            var _this = this
            if (e == 'qq') {
                QC.Login.showPopup({
                    appId: '101975801',
                    redirectURI: 'https://web.imbeiyu.com'
                })
            } else {
                _this.$message('正在申请开通微信登录，请用账号密码登录！');
            }
        },
        login() { // 登录
            var _this = this

            console.log(_this.form2.nnid.length)
            var code = 0
            var authType = "password"
            if (_this.form2.nnid.length == 11) {
                code = 86
                authType = "code"
            }
            console.log('login', _this.$api.login)
            _this.$http.post(_this.$api.login, {
                authType: authType,
                areaCode: code,
                number: _this.form2.nnid,
                password: _this.form2.psd
            }).then(function (response) {
                if (response.data.state) {
                    var userinfo = response.data.userCommon
                    userinfo.loginKey = response.data.loginKey
                    userinfo = JSON.stringify(userinfo);
                    _this.resetSetItem('userinfo', userinfo);
                    //  localStorage.setItem("userinfo", userinfo);

                    _this.islogin = false
                } else {
                    _this.$message.error(response.data.msg);
                }



            })
        },

        changedl(flg) {
            if (flg == 1) {
                this.isphone = false
            } else {
                this.isphone = true
            }

        },


        //获取验证码    
        //获取验证码 并只验证手机号 是否正确
        getCode() {
            this.$refs['loginForm'].validateField('phone', (err) => {
                if (err) {
                    console.log('未通过')
                    return;
                } else {
                    console.log('已通过')
                    this.tackBtn();   //验证码倒数60秒
                    let fd = new FormData();  //POST 请求需要 转化为Form
                    fd.append('PhoneNumber', this.form.phone);
                    fd.append('NeedCheck', 2);
                    this.$axios({
                        method: 'POST', data: fd, url: '/api/sgsaccount/vcodeget',
                    }).then(res => {
                        console.log(res);
                    })
                }
            })
        },
        tackBtn() {       //验证码倒数60秒
            let time = 60;
            let timer = setInterval(() => {
                if (time == 0) {
                    clearInterval(timer);
                    this.valiBtn = '获取验证码';
                    this.disabled = false;
                } else {
                    this.disabled = true;
                    this.valiBtn = time + '秒后重试';
                    time--;
                }
            }, 1000);
        },
        onSubmit(formName) {  //点击登录 验证手机& 验证码是否符合条件
            this.$refs[formName].validate((valid) => {    // 为表单绑定验证功能
                if (valid) {
                    let fd = new FormData();
                    fd.append('PhoneNumber', this.form.phone);
                    fd.append('VCode', this.form.code);
                    this.$axios({
                        method: 'POST', data: fd, url: `/api/sgsaccount/adminlogin`,
                    }).then(res => {
                        console.log(res);
                        if (res.data.EID == 0) {
                            var token = res.data.Data[0].token;
                            localStorage.setItem('token', token);
                            this.$message({ showClose: true, message: '登录成功', type: 'success' })
                            this.$router.push({ path: '/indexx' });
                        } else {
                            this.$message({ showClose: true, message: res.data.Err, type: 'warning' })
                        }
                    });
                } else {
                    this.dialogVisible = true;
                    return false;
                }
            });
        },
    },
}
</script>
<style lang="less" scoped>
.txttt {
    width: 100%;
    text-align: center;
    font-size: .04rem;
    color: rgba(31, 45, 61, 1);

    a {
        color: rgba(69, 148, 255, 1);
        cursor: pointer;
    }
}

.dlfs {
    cursor: pointer;
    float: right;
    height: .1rem;
    margin-bottom: .1rem;
    font-size: .09rem;
    color: rgba(69, 148, 255, 1);
}

.verify-wrapper {
    display: flex;
    align-items: center;
    height: .3rem;

    .btn-orange {
        border: 1Px solid rgba(192, 204, 218, .0);
        height: 100%;
        padding: 0 .1rem;
        color: #fff;
        font-size: .12rem;
        margin-left: .1rem;
        background: linear-gradient(90deg, rgba(69, 146, 254, 1) 0%, rgba(80, 221, 254, 1) 100%);
    }

}

.el-form-item {
    margin-bottom: 0.18rem;
}

.qtbuns {
    width: 100%;
    height: .4rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.d-btn-qq {
    background: url('https://resource.imbeiyu.com/gw/assets/PC/qqbtn.png');
    background-size: 100% 100%;
    width: .3rem;
    margin-right: .35rem;
    height: .3rem;
}

.d-btn-wx {
    background: url('https://resource.imbeiyu.com/gw/assets/PC/wxbtn.png');
    background-size: 100% 100%;
    width: .3rem;
    height: .3rem;
}

.d-btn-orange {
    width: 100%;
    height: .3rem;
    margin-top: .1rem;

    color: #fff;
    font-size: .12rem;
    background: linear-gradient(90deg, rgba(69, 146, 254, 1) 0%, rgba(80, 221, 254, 1) 100%);
}
</style>


// WEBPACK FOOTER //
// src/components/pclogin.vue